export const mutations = {
  setEpisodes(state, episodes) {
    state.episodes = episodes
  },
  setTags(state, tags) {
    state.tags = tags
  }
}